import { useMutation } from '@apollo/client'
import SET_ORDER_DETAILS_MUTATION from './SET_ORDER_DETAILS_MUTATION'

const useCustomSetOrderDetails = () => useMutation(SET_ORDER_DETAILS_MUTATION)

export default useCustomSetOrderDetails
